import { useEffect, useMemo, useSyncExternalStore } from "react";
import type { UserFile } from "../api/finster/userFiles";
import {
  ensureUserFiles,
  getCachedUserFiles,
  getUserFilesStoreVersion,
  subscribeToUserFiles,
} from "../api/finster/userFilesStore";

export function useUserFileLookup(fileIds: readonly string[]): Map<string, UserFile> {
  const storeVersion = useSyncExternalStore(
    subscribeToUserFiles,
    getUserFilesStoreVersion,
    () => 0,
  );

  useEffect(() => {
    if (fileIds.length === 0) {
      return;
    }

    const cached = getCachedUserFiles();
    if (!cached) {
      void ensureUserFiles();
    }
  }, [fileIds]);

  return useMemo(() => {
    const lookup = new Map<string, UserFile>();
    const cached = getCachedUserFiles();
    if (!cached) {
      return lookup;
    }

    for (const fileId of fileIds) {
      const file = cached.find((candidate) => candidate.id === fileId);
      if (file) {
        lookup.set(fileId, file);
      }
    }

    return lookup;
  }, [fileIds, storeVersion]);
}
